<template>

  <div ref="container" :style="{ height: containerHeight}" class="widget" :id="mode">
      <v-container fluid v-if="!this.uuid" style="min-height:200px;">
        <v-row
          align="center"
          justify="center"
        >
          <v-col><h3 class="animated fadeIn text-center mt-10">No query string provided.</h3></v-col>
        </v-row>
      </v-container>

      <v-container fluid v-if="error" style="min-height:200px;">
        <v-row
          align="center"
          justify="center"
        >
          <v-col><h3 class="animated fadeIn text-center mt-10">An error has occurred, please try to refresh or contact support at <a href="mailto:support@curepayapp.com">support@curepayapp.com</a>.</h3></v-col>
        </v-row>
      </v-container>
      
      <transition name="fade">
        <v-stepper
          v-model="currentStep"
          :elevation="0"
          v-if="experienceLoaded"
          transition="fade-transition"
          ref="stepper"
          class="no-transition"
        >
          <v-stepper-header >
            <template v-for="(step, index) in steps">
              <v-stepper-step
                :key="`${step.title}-step`"
                :complete="currentStep > index + 1"
                :step="index + 1"
                :color="primaryColor"
                @click="stepClick(index)"
              >
                {{ step.title }}
              </v-stepper-step>
              <v-divider v-if="index + 1 !== steps.length" :key="step.title" />
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1" class="animated fadeIn">
              <Calculate v-if="currentStep == 1" @purchase="proceedToCheckout($event)" ref="calculate" :minbuy="minbuy" :maxbuy="maxbuy" />
            </v-stepper-content>
            <v-stepper-content step="2" class="animated fadeIn">
              <Checkout v-if="currentStep == 2" :embedded="embedded" @process="proceedToProcess($event)" ref="checkout" />
            </v-stepper-content>
            <v-stepper-content step="3" class="animated fadeIn">
              <Process v-if="currentStep == 3" ref="process" />
            </v-stepper-content>
            <v-stepper-content step="4" class="animated fadeIn">
              <Complete v-if="currentStep == 4" :embedded="embedded" ref="complete" />
            </v-stepper-content>
          </v-stepper-items>
          <div class="Footer-PoweredBy mt-0" v-if="!embedded">
            
            <span v-if="exp == 'alpha'" class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">Powered by <svg class="InlineSVG Icon Footer-PoweredBy-Icon Icon--md" focusable="false" width="120" height="14" role="img" aria-labelledby="stripe-title"><title id="stripe-title">CURE</title><g fill-rule="evenodd"><path class="cls-1" d="M4,3.87c1.64,0,3.38.54,3.38,1.93V7.09H5V6.68c0-.26-.27-.4-.8-.4-1,0-1.23.63-1.23,1.3a1.35,1.35,0,0,0,1.5,1.5,3.41,3.41,0,0,0,2.13-.75l1,2a4.87,4.87,0,0,1-3.28,1.1C2,11.47,0,10.09,0,7.69A3.85,3.85,0,0,1,4,3.87Z"/><path class="cls-1" d="M13.53,6.11h-.89V4h3.81V8.91a.29.29,0,0,0,.31.31h.53V11.3H14.72c-.69,0-1.05-.3-1.05-.89,0-.17,0-.35,0-.35h0a2.33,2.33,0,0,1-2.31,1.41c-1.21,0-2.43-.6-2.43-2.69V6.11H8.05V4h3.81V8.26c0,.49.17.66.53.66.77,0,1.14-.84,1.14-1.76Z"/><path class="cls-1" d="M18.12,9.23h.93V6.42a.28.28,0,0,0-.3-.31h-.58V4h2.61c.67,0,1.08.27,1.08,1v.35a1.3,1.3,0,0,1,0,.31h0a2.53,2.53,0,0,1,2.31-1.77l.25,0V6.78a3.12,3.12,0,0,0-.53,0c-1.28,0-1.91.54-1.91,1.82v.67h.94V11.3h-4.8Z"/><path class="cls-1" d="M28.67,3.87A3.3,3.3,0,0,1,32.2,7.31a7.15,7.15,0,0,1-.05.8H27.81a1.29,1.29,0,0,0,1.37,1,4.54,4.54,0,0,0,2-.63l1,2a5.39,5.39,0,0,1-3.24,1,3.78,3.78,0,0,1-4.09-3.86A3.64,3.64,0,0,1,28.67,3.87Zm.54,3c0-.49-.12-1-.63-1s-.69.74-.72,1Z"/><path class="cls-1" d="M40.54,0h2.4V13.66h-2.4Z"/><path class="cls-1" d="M51.1,9.15h.76l2.53-7.92h3.46l2.54,7.92h.77V11.3H56.6V9.15h.79l-.2-.93H55.05l-.2.93h.79V11.3H51.1Zm5.63-2.92-.32-1.38c-.17-.75-.25-1.35-.25-1.35h-.07a10.81,10.81,0,0,1-.26,1.35L55.5,6.23Z"/><path class="cls-1" d="M62,3.31h-.89V1.23H64.9v7c0,.72.12.88.64.88h.25v2.3a7.75,7.75,0,0,1-.79,0c-1.41,0-3-.27-3-3.06Z"/><path class="cls-1" d="M67.35,12V6.42a.28.28,0,0,0-.3-.31h-.58V4H69c.58,0,1,.17,1,.69a1,1,0,0,1,0,.14h0a2.63,2.63,0,0,1,2.17-1c1.88,0,3.25,1.55,3.25,3.78s-1.5,3.82-3.35,3.82a2.61,2.61,0,0,1-1.76-.6h0a3.75,3.75,0,0,1,0,.55V12h.82v2.08H66.54V12Zm3.94-2.95c.64,0,1.15-.48,1.15-1.36S72,6.3,71.32,6.3s-1.14.45-1.14,1.38C70.18,8.4,70.53,9.08,71.29,9.08Z"/><path class="cls-1" d="M76.06,9.23h.81V3.31H76V1.23H79.8v3.1a4.4,4.4,0,0,1,0,.63h0a2.58,2.58,0,0,1,4.68,1.6V9.23h.81V11.3H81.54V7.13c0-.49-.18-.63-.55-.63-.91,0-1.19.85-1.19,1.67V9.23h.81V11.3H76.06Z"/><path class="cls-1" d="M89.49,6.91h.42V6.58c0-.33-.39-.46-.79-.46a4.44,4.44,0,0,0-2,.69l-1-2a5.85,5.85,0,0,1,3.31-1c2.11,0,3.36,1.09,3.36,3v2a.29.29,0,0,0,.31.31h.44V11.3H91.2a.92.92,0,0,1-1-.89v0a.8.8,0,0,1,0-.11h0a2.29,2.29,0,0,1-2.06,1.15,2.2,2.2,0,0,1-2.34-2.14C85.78,7.2,88.4,6.91,89.49,6.91Zm-.41,2.62a1,1,0,0,0,.87-1V8.21h-.17c-.88,0-1.19.42-1.19.8A.48.48,0,0,0,89.08,9.53Z"/><path class="cls-1" d="M97.79,9.15h.73l2.44-3L98.67,3.39h-.81V1.23h4.51V3.39h-.64l.63.76a4.51,4.51,0,0,1,.35.5h0s.13-.21.35-.5l.61-.76h-.63V1.23h4.23V3.39h-.73l-2.41,2.94,2.35,2.82h.76V11.3h-4.53V9.15h.72l-.7-.84a5.19,5.19,0,0,1-.35-.51h0s-.14.23-.35.51l-.63.84h.67V11.3H97.79Z"/></g></svg></span>

            <a class="Link Link--primary" v-else href="https://www.curepayapp.com" target="_blank" rel="noopener"><span class="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">Powered by <svg class="InlineSVG Icon Footer-PoweredBy-Icon Icon--md" focusable="false" viewBox="-3 -4 35 12" height="20" role="img" aria-labelledby="stripe-title"><title id="stripe-title">CURE</title><g fill-rule="evenodd"><path class="cls-1" d="M4.26,5.55A1.68,1.68,0,0,1,2.44,3.71,1.49,1.49,0,0,1,4.05,2c.56,0,1,.18,1,.53V3H7.13V1.83C7.13.5,5.39,0,4,0A3.79,3.79,0,0,0,0,3.8,3.83,3.83,0,0,0,4.1,7.55,4.8,4.8,0,0,0,7.24,6.44L6.43,4.75A3.67,3.67,0,0,1,4.26,5.55Z"/><path class="cls-1" d="M16,5.32V.17H12.6V1.92h1v1.3c0,1.09-.54,2.2-1.5,2.2-.53,0-.79-.28-.79-1V.17H7.88V1.92h1V4.85c0,2,1.1,2.7,2.37,2.7a2.61,2.61,0,0,0,2.45-1.39h0s0,.12,0,.21v.2c0,.49.33.81,1,.81h2.23V5.63h-.61A.28.28,0,0,1,16,5.32Z"/><path class="cls-1" d="M21.16,1.83h0a1.89,1.89,0,0,0,0-.36V1.09c0-.66-.37-.92-1-.92H17.85V1.92h.67a.28.28,0,0,1,.31.31v3.4h-1V7.38h4.38V5.63h-1v-1c0-1.32.65-2.17,2-2.17a2.62,2.62,0,0,1,.49,0V.07a1.53,1.53,0,0,0-.28,0A2.48,2.48,0,0,0,21.16,1.83Z"/><path class="cls-1" d="M28.48,5.55A1.61,1.61,0,0,1,26.8,4.22h4.58s.05-.49.05-.73A3.2,3.2,0,0,0,28.07,0a3.59,3.59,0,0,0-3.75,3.77,3.73,3.73,0,0,0,4,3.78,5,5,0,0,0,3.11-1l-.88-1.68A4,4,0,0,1,28.48,5.55ZM28,1.82a1,1,0,0,1,.91,1.07H26.85A1.19,1.19,0,0,1,28,1.82Z"/></g></svg></span></a>
          </div>


          
        </v-stepper>
      </transition>

  </div>

</template>

<script>
import axios from 'axios';
import Calculate from './Calculate.vue';
import Process from './Process.vue';
import Complete from './Complete.vue';
import Checkout from './Checkout.vue';
import $ from 'jquery'

export default {
  props:[
    'clientID',
    'user',
    'email',
    'embedded',
  ],
  data() {
    return {
      price: [],
      message: '',
      test: "test",
      show: false,
      showMessage: false,
      experienceLoaded: false,
      stripe: null,
      currentStep: 0,
      tokenName: "",
      tokenIcon: "",
      currentPrice: "",
      processingFees: "",
      primaryColor: "",
      purchaseAmount: "",
      reciept: {},
      uuid: "",
      token: "",
      customer:{},
      error:false,
      containerHeight: '0px',
      timer: '',
      mode: 'light',
      exp: 'cure',
      steps: [
        {
          title: 'Calculate',
          component: 'Calculate',
          ref: 'calculate,'
        },
        {
          title: 'Checkout',
          component: 'Checkout',
          ref: 'checkout,'
        },
        {
          title: 'Process',
          component: 'Process',
          ref: 'process,'
        },
        {
          title: 'Complete',
          component: 'Complete',
          ref: 'complete,'
        },
      ],
    };
  },
  components: {
    Calculate,
    Checkout,
    Process,
    Complete,
  },
  methods: {
    iframeHeightNotify(){
      this.containerHeight = this.$refs.container.scrollHeight + "px";
      var msg = {
        height: this.$refs.container.scrollHeight
      }
      window.parent.postMessage(msg,'*')
    },
    stepClick(index){
      //console.log(index);
      //console.log(this.currentStep);
      if(this.currentStep == 2 && index == 0) this.currentStep = 1
    },
    get_experience() {    
      const path = `${this.$domainPath}/get-experience`;
      if(!this.uuid) return;

      fetch(path, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 'uuid': this.uuid }),
      })
        .then((result) => result.json())
        .then((data) => {          
          //console.log(data);
          
          this.$emit("getProject", data);
          
          if(data.status == "error"){
            this.error = true;
          }else{
            this.tokenName = data.name;
            this.tokenIcon = data.icon;          
            this.price = data.price;
            this.currentPrice = data.price;
            this.processingFees = data.percent;
            this.primaryColor = data.color;
            this.minbuy = data.minbuy;
            this.maxbuy = data.maxbuy;
            this.source = data.source;
            this.experienceLoaded = true;
            this.currentStep = 1;

            $('head').append(`<style id="text-module-style">.v-stepper__header, .theme--light.v-stepper .v-stepper__step__step, .theme--light.v-stepper .v-stepper__step__step .v-icon {
              color: ` + this.primaryColor + `;
              background-color: ` + this.primaryColor + `;
            }.v-stepper__step--complete .v-stepper__step__step, .v-stepper__step--active .v-stepper__step__step {
    background-color: #fff !important;
    color: v-bind('primaryColor') !important;
  }</style>`)
          }
        });
    },
    proceedToComplete() {

    },
    proceedToCheckout(purchaseAmount) {
      this.purchaseAmount = purchaseAmount;
      this.currentStep = 2;
    },
    proceedToProcess(obj) {
      this.token = obj['token'];
      this.customer = obj['customer'];
      this.currentStep = 3;
    },
    getStripePublishableKey() {
      const path = `${this.$domainPath}/config`
      fetch(path)
        .then((result) => result.json())
        .then((data) => {
          this.stripe = Stripe(data.publicKey); // eslint-disable-line no-undef
        });
    },
  },
  created() {
    const params = new URLSearchParams(window.location.search);

    this.uuid = params.get('clientID');
    this.mode = params.get('mode');
    this.exp = params.get('exp');
      
    if(!this.uuid){
      this.uuid = this.clientID;
    }

    if(this.mode == 'dark'){
      this.$vuetify.theme.dark = true;
    }

    /*
    console.log(this.uuid);
    console.log(this.mode);
    console.log(this.exp);
    */

    if(this.embedded){
      this.customer['firstName'] = this.user.firstname
      this.customer['lastName'] = this.user.lastname
      this.customer['email'] = this.email
    }
    this.get_experience();
  },
  mounted() {
    this.timer = setInterval(this.iframeHeightNotify, 300)
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>


<style>

  /*#dark .v-stepper{
    background: black;
  }

  #light .v-stepper{
    background: white;
  }*/

  .v-stepper--is-booted .v-stepper__content, .v-stepper--is-booted .v-stepper__wrapper {
    transition: none !important;
  }

  .v-sheet.v-stepper {
    border-radius: 20px;
  }

  .widget {
    border-radius: 20px;
    box-shadow: 10px 20px 40px 20px rgba(0,0,0,.04), 0 8px 38px 7px rgba(0,0,0,.04) !important;
  }

  .stepper__content {
    transform-origin: center top 100px !important;
  }

  .v-stepper__header{
    box-shadow:  none;
  }

  .theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
    text-shadow: none;
  }

  h2{
    font-size: 2.5em;
    line-height: 1em;
  }

  a {
    color: orange !important;
  }

  .v-list-item--link{
    cursor: inherit;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .v-stepper__content {
    padding: 0px;
    min-height:  580px !important;
  }

  .theme--light.v-card>.v-card__text{
    color: rgba(0,0,0,.87);
  }

  .v-stepper__step--complete .v-stepper__step__step, .v-stepper__step--active .v-stepper__label, .v-stepper__step--complete .v-stepper__label {
    color: #fff !important;
  }
    
  .theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
    background: rgba(0,0,0,.2);
  }

  span.v-stepper__step__step {
    color: inherit !important;
  }

  .v-divider{
    border-color: rgba(0,0,0,.2) !important;
    background-color: transparent !important;
  }

  .v-stepper__step .v-stepper__step--active .v-stepper__step__step {
    background-color: #fff !important;
  }

  .v-stepper__step .v-stepper__step--complete .v-stepper__step__step .v-icon {
    background-color: #fff !important;
  }

  .v-stepper__step--complete .v-icon{
    background-color: transparent !important;
  }

  .Footer-PoweredBy{
    text-align: center;
    margin:  20px;
    fill:  var(--v-primary-base);
  }

  .Footer-PoweredBy svg{
    fill:  var(--v-primary-base);
  }

  .Footer-PoweredBy-Icon {
    fill: hsl(0deg 0% 0% / 25%);
    margin: -3px 0px;
  }
  
  .Footer-PoweredBy a{
    text-decoration: none;
  }

  .Footer-PoweredBy .Text {
    color: var(--v-primary-base);
    font-size: 11px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif;
  }

  .animated {
    background-repeat: no-repeat;
    background-position: left top;
    -webkit-animation-duration: .5s !important;
    animation-duration: .5s !important;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    animation-delay: .2s;
  }
   
  @-webkit-keyframes fadeIn2 {
    0% {
      opacity: 0;
      transform:
        scale(1.05);
    }
    100% {
      opacity: 1;
      transform:
        scale(1);
    }
  }
   
  @keyframes fadeIn2 {
    0% {
      opacity: 0;
      transform:
        scale(1.05);
    }
    100% {
      opacity: 1;
      transform:
        scale(1);
    }
  }
   
  .fadeIn {
    -webkit-animation-name: fadeIn2 !important;
    animation-name: fadeIn2 !important;
  }




</style>